module.exports = __webpack_public_path__ + "img/CockUp.69801aca.svg";